import React from 'react';
import styles from './styles.scss';

export default function Header({ children }) {
  return (
    <h3 className={styles.header}>{children}</h3>
  );
}
